import script from "./VitalSignsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./VitalSignsChart.vue?vue&type=script&setup=true&lang=js"

import "./VitalSignsChart.vue?vue&type=style&index=0&id=64f24e0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f24e0a"]])

export default __exports__